// Integer enums for the Messages table (stored as TINYINT). Shared so the backend
// and admin agree on the codes. Compare against these constants — never magic
// numbers. Mirrors the CommonJS style of FilterUtil.

// Messages.type — what kind of message this is.
const MESSAGE_TYPE = Object.freeze({
  ANNOUNCEMENT: 1, // admin broadcast
  SYSTEM_EVENT: 2, // auto-generated (activity note / mileage log assigned)
  DIRECT: 3,       // user-to-user (model-ready; not built)
});

// Messages.audience_type — how the recipients were chosen. Descriptive only;
// MessageRecipients is the source of truth for who actually receives a message.
const AUDIENCE_TYPE = Object.freeze({
  SYSTEM: 1, // everyone (all active users)
  USERS: 2,  // a specific picked list
});

module.exports = {
  MESSAGE_TYPE,
  AUDIENCE_TYPE,
};
